// extracted by mini-css-extract-plugin
export var active = "_au-d";
export var blink = "_au-e";
export var container = "_au-5";
export var controls = "_au-0";
export var controlsRight = "_au-1";
export var fakeCursor = "_au-c";
export var hidden = "_au-b";
export var quillContainerSmall = "_au-7";
export var quillEditor = "_au-6";
export var quillEditorSmall = "_au-8";
export var quillFormatButtons = "_au-a";
export var quillToolbar = "_au-9";
export var removePadding = "_au-2";
export var state = "_au-3";
export var stateTitle = "_au-4";